import { ListItem, ListItemText } from "common/components";
import { FlowData, FlowStep } from "core/api";
import { useTranslation } from "i18n";
import { Fragment } from "react";

export interface CreditNoteReasonProps {
  step: FlowStep;
  flowData: FlowData;
}

/**
 * Sub component to confirmation. The purpose of this component is
 * to make the main Confirmation component more readable,
 * abstracting some of the logic into smaller sub components.
 *
 * CreditInvoiceConfirmation is specific to confirmation steps where
 * the flow contains a step with the uiComponent: "CreditNoteReason".
 *
 * @param step The current step in the parent components loop.
 * @param flowData data property from the flow object, this is fetched through
 * const flowData = flow.data[step.id]; in the parent component.

 *
 * @returns A JSX element with invoice details from the previous "CreditNoteReason" step in the flow.
 */
export function CreditNoteReasonConfirmation({
  step,
  flowData,
}: CreditNoteReasonProps): JSX.Element {
  const { t } = useTranslation(["common"]);
  const fieldFlowData =
    flowData.uiComponent === "CreditNoteReason" ? flowData : undefined;

  return (
    <Fragment key={step.id}>
      <ListItem>
        <ListItemText
          primary={t("invoice:creditNoteReason.creditReason")}
          secondary={fieldFlowData?.creditReason.name}
        />
      </ListItem>
      <ListItem>
        <ListItemText
          primary={t("invoice:creditNoteReason.text")}
          secondary={fieldFlowData?.text}
        />
      </ListItem>
    </Fragment>
  );
}
